import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isEndOfQuarter = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).endOf('quarter'), 'day');
};

export default isEndOfQuarter;
